export enum SiteSelectorAppearance {
  DEFAULT = 'default',
  PAGE_HEADER = 'page_header',
  SECONDARY_HEADER = 'secondary_header',
}
